
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/horse-racing/horse-betting-terms",
      function () {
        return require("private-next-pages/horse-racing/horse-betting-terms.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/horse-racing/horse-betting-terms"])
      });
    }
  